import * as e from "react";
import { forwardRef as t } from "react";
const l = t(function(L, o) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: o,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...L
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M7.52655 16.4476L14.1109 6.20263L16.9455 7.0543L17.7855 9.85073L7.52655 16.4476ZM5.77324 15.7717C5.67073 15.668 5.59617 15.5401 5.55655 15.3997C5.51692 15.2594 5.51352 15.1113 5.54665 14.9693L5.57322 14.8732L9.46817 3.61404C9.68929 2.97334 10.5027 2.79676 10.9441 3.26244L11.0019 3.33041L12.6927 5.52052L5.97326 15.9726L5.77324 15.7717ZM8.00004 17.9986L18.4481 11.2837L20.6694 12.998C21.1671 13.3824 21.0804 14.1411 20.56 14.4513L20.478 14.495L20.3858 14.5318L9.12673 18.4268C8.84076 18.5252 8.53057 18.4729 8.30164 18.2916L8.22819 18.2267L8.00082 17.9994L8.00004 17.9986ZM3.68629 20.3137C3.24686 19.8741 3 19.278 3 18.6565C3 18.0349 3.24686 17.4388 3.68629 16.9992L4.2387 16.4468L7.55312 19.7613L7.00072 20.3137C6.56115 20.7531 5.96505 21 5.3435 21C4.72196 21 4.12586 20.7531 3.68629 20.3137Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  l as Badminton
};
